export const CSS_CLASSES = {
  ROOT: "Backdrop",
  OPAQUE: "bk-op",
  DARK: "bk-d",
  CLICKABLE: "bk-c",
};
